import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 7.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M8.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.683 11.69 22 12l.683.31-.002.004-.003.006-.01.02a8 8 0 0 1-.169.345 20.326 20.326 0 0 1-2.542 3.801C18.201 18.549 15.511 20.75 12 20.75c-3.51 0-6.2-2.202-7.957-4.264a20.3 20.3 0 0 1-2.676-4.071l-.036-.074-.01-.021-.002-.006-.001-.002s0-.002.682-.312l-.683-.31.002-.004.003-.006.01-.02a8 8 0 0 1 .169-.345 20.314 20.314 0 0 1 2.542-3.801C5.799 5.452 8.49 3.25 12 3.25s6.2 2.202 7.957 4.264a20.3 20.3 0 0 1 2.677 4.071l.023.049.012.025.01.021.002.006zM3.314 12.87a17 17 0 0 1-.478-.868v-.004a18.815 18.815 0 0 1 2.348-3.511C6.837 6.546 9.147 4.75 12 4.75s5.163 1.798 6.816 3.736a18.8 18.8 0 0 1 2.348 3.512v.004a18.818 18.818 0 0 1-2.348 3.511c-1.653 1.94-3.963 3.737-6.816 3.737s-5.163-1.798-6.816-3.736a19 19 0 0 1-1.87-2.644M22 12l.683-.31c.09.196.09.424 0 .62z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.317 11.69 2 12l-.683.31a.75.75 0 0 1 0-.62"
    }, null, -1)
  ])))
}
export default { render: render }